import { Box, CircularProgress, Stack, Typography } from "@mui/material"
import { TabledRepeat } from "lib/@components/tabled-repeat/tabled-repeat"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import { getMaintenanceTasks } from "../../controller/maintenance-library"
import { DraftComponentRow } from "./draft-component-row"
import { useEffect } from "react"
import { ResetTabledRepeat } from "event-definitions"

const TAKE = 1000

const TABLE_HEADERS = [
    { title: "Component", fieldKey: "heading", sortable: true },
    { title: "Location", fieldKey: "categoryPath", sortable: true, sx: { width: "40%" } },
]

const TABLE_SX = { tableLayout: "fixed", width: "100%" }

const SEARCH_KEYS = [
    { key: "heading", title: "Component" },
    { key: "categoryPath", title: "Location" },
]

export function DraftComponentsList() {
    const results = getMaintenanceTasks.useResults({
        draftsOnly: true,
        skip: 0,
        take: TAKE,
        orderStmt: ["heading"],
    })
    const { items = [], totalCount = 0 } = results ?? {}
    const isLoading = results === undefined

    useEffect(() => {
        ResetTabledRepeat.raiseOnce()
    }, [results])

    return (
        <Box data-cy="draft-components-list">
            <Typography variant="subtitle1" sx={{ mb: 1 }}>
                {getTitle()}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Components awaiting review. They will not appear in searches or the component picker until they have
                been approved.
            </Typography>

            <If value={isLoading}>
                <Stack alignItems="center" sx={{ py: 5 }}>
                    <CircularProgress />
                </Stack>

                <Else>
                    <TabledRepeat
                        items={items}
                        itemPass="item"
                        itemComponent={<DraftComponentRow />}
                        tableHeaders={TABLE_HEADERS}
                        searchKeys={SEARCH_KEYS}
                        sx={TABLE_SX}
                        paged
                    />
                </Else>
            </If>
        </Box>
    )

    function getTitle() {
        if (!totalCount) return "Draft Components"
        return `Draft Components (${totalCount})`
    }
}
